import React, { useCallback } from "react";
import { useDropzone } from "react-dropzone";

function FileUpload({ onFilesSelected }) {
  const onDrop = useCallback(
    async (acceptedFiles) => {
      // Process each file and prepare it for output
      const files = await Promise.all(
        acceptedFiles.map(async (file) => {
          return file;
        })
      );

      // Send file data to the parent component
      onFilesSelected(files);
    },
    [onFilesSelected]
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
  });

  return (
    <div
      {...getRootProps()}
      className={`upload-container ${isDragActive ? "active" : ""}`}
    >
      <input {...getInputProps()} />
      <div className="upload-text">
        {isDragActive ? (
          <p>Drop the files here ...</p>
        ) : (
          <p>Drag & drop files here, or click to select files</p>
        )}
      </div>
    </div>
  );
}

export default FileUpload;
